import { useTypedQuery } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Brand } from "models";

const getActiveBrands = (brands: Brand[]) => brands.filter(brand => brand.is_active);

export const useActiveBrandsQuery = () =>
  useTypedQuery({
    queryKey: BrandsDashboardQueryKeys.brands,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, {}, baseUrl)).data.brands,
    select: getActiveBrands
  });
